import { VitalRowDef } from "./readmission-f2f-types";

export const VITAL_ROWS: VitalRowDef[] = [
  {
    key: "bloodPressure",
    label: "Blood pressure",
    unit: "mmHg",
    placeholder: "120/80",
    format: "bloodPressure",
    maxLength: 7,
  },
  {
    key: "pulse",
    label: "Pulse",
    unit: "bpm",
    placeholder: "72",
    format: "number",
    maxLength: 3,
    min: 20,
    max: 250,
    decimals: 0,
    rangeMessage: "Pulse must be between 20 and 250 bpm.",
  },
  {
    key: "respirations",
    label: "Respirations",
    unit: "/min",
    placeholder: "16",
    format: "number",
    maxLength: 2,
    min: 4,
    max: 60,
    decimals: 0,
    rangeMessage: "Respirations must be between 4 and 60 /min.",
  },
  {
    key: "temperature",
    label: "Temperature",
    unit: "°F",
    placeholder: "98.6",
    format: "number",
    maxLength: 5,
    min: 90,
    max: 110,
    decimals: 1,
    rangeMessage: "Temperature must be between 90.0 and 110.0 °F.",
  },
  {
    key: "spo2",
    label: "SpO2",
    unit: "%",
    placeholder: "97",
    format: "number",
    maxLength: 3,
    min: 50,
    max: 100,
    decimals: 0,
    rangeMessage: "SpO2 must be between 50 and 100%.",
  },
  {
    key: "height",
    label: "Height",
    unit: "cm",
    placeholder: "170",
    format: "number",
    maxLength: 5,
    min: 30,
    max: 250,
    decimals: 1,
    rangeMessage: "Height must be between 30 and 250 cm.",
  },
  {
    key: "weight",
    label: "Weight",
    unit: "kg",
    placeholder: "68",
    format: "number",
    maxLength: 5,
    min: 1,
    max: 300,
    decimals: 1,
    rangeMessage: "Weight must be between 1 and 300kg.",
  },
];
export const UNABLE_TO_ASSESS_LABEL = "Unable to assess or obtain";
export const VITAL_CHECK_VALUE_MESSAGE = "Please check this value";
export const BLOOD_PRESSURE_FORMAT_MESSAGE =
  "Enter systolic/diastolic, e.g. 120/80";
export const BLOOD_PRESSURE_ORDER_MESSAGE =
  "Systolic must be higher than diastolic";
export const SYSTOLIC_RANGE = { min: 50, max: 300 } as const;
export const DIASTOLIC_RANGE = { min: 30, max: 200 } as const;
export const SYSTOLIC_RANGE_MESSAGE =
  "Systolic must be between 50 and 300 mmHg.";
export const DIASTOLIC_RANGE_MESSAGE =
  "Diastolic must be between 30 and 200 mmHg.";
